/**
 * 极简 toast：右下角浮层，3 秒自动消失
 */
let host: HTMLDivElement | null = null;

function ensureHost(): HTMLDivElement {
  if (host && document.body.contains(host)) return host;
  host = document.createElement('div');
  host.className = 'toast-host';
  document.body.appendChild(host);
  return host;
}

export function toast(message: string, duration = 1800): void {
  const el = document.createElement('div');
  el.className = 'toast';
  el.textContent = message;
  ensureHost().appendChild(el);
  // 强制重排再加 show class 触发动画
  void el.offsetWidth;
  el.classList.add('toast--show');
  setTimeout(() => {
    el.classList.remove('toast--show');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
  }, duration);
}
